function validation_error(step, form) {
  const validators = new Map([
    [2, () => form.domains.length ? '' : 'Select at least one case domain.'],
    [3, () => form.roles.length ? '' : 'Select at least one role.']
  ]);
  return validators.get(step)?.() || '';
}

async function save_step(settings) {
  const savers = new Map([
    [1, () => settings.save_tenant_setup_project()],
    [3, () => settings.save_tenant_role_assignments()]
  ]);
  const save = savers.get(settings.tenant_setup_step);
  return save ? save() : true;
}

export async function advance_tenant_setup(settings) {
  const error = validation_error(settings.tenant_setup_step, settings.tenant_setup_form);
  if (error) {
    settings.show_error(error);
    return;
  }
  const saved = await save_step(settings);
  if (!saved) return;
  if (settings.tenant_setup_step < 5) settings.tenant_setup_step += 1;
}
